import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoggerService, normalizeHttpError, OccEndpointsService } from '@spartacus/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NewsLetterAdapter } from './news-letter.adapter';
import {
  CDCSubscriptionData,
  SubscriptionBaseData,
  SubscriptionCheckData,
  SubscriptionData,
  SubscriptionLocation,
  SubscriptionSettingCollection,
  SubscriptionSettingVersion,
  SubscriptionSettingVersionList,
} from '../../model/subscription.model';

@Injectable({
  providedIn: 'root',
})
export class OccNewsLetterAdapter implements NewsLetterAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  subscribe(data: SubscriptionData): Observable<string> {
    const url = this.occEndpoints.buildUrl('subscribe');
    return this.http
      .post(url, data, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  unsubscribe(data: SubscriptionBaseData): Observable<string> {
    const url = this.occEndpoints.buildUrl('unsubscribe');
    return this.http
      .post(url, data, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  getSubscription(): Observable<SubscriptionSettingCollection> {
    const url = this.occEndpoints.buildUrl('subscriptions');

    return this.http.get<SubscriptionSettingCollection>(url).pipe(catchError((error) => of(error)));
  }

  subscribeRegistrationCDC(data: CDCSubscriptionData): Observable<string> {
    const url = this.occEndpoints.buildUrl('subscribeRegisterCDC');
    return this.http
      .post<string>(url, data, { responseType: 'text' as any })
      .pipe(catchError((error) => throwError(() => normalizeHttpError(error, this.logger))));
  }

  getSubscriptionByLocation(location: SubscriptionLocation): Observable<SubscriptionSettingVersion[]> {
    const url = this.occEndpoints.buildUrl('subscriptionByLocation', {
      urlParams: { location },
    });

    return this.http.get<SubscriptionSettingVersionList>(url).pipe(
      map((response) => response.subscriptionSettings),
      catchError((error) => throwError(() => normalizeHttpError(error, this.logger)))
    );
  }
}
